import { createFileRoute } from '@tanstack/react-router';

// The list alone, with no element open
export const Route = createFileRoute('/_authenticated/rtelements/')({});
